export default "__VITE_PUBLIC_ASSET__cfb567be__"